import axiosInstance from '../axiosInstance';

// 정책 문서 버전 API (공개 조회 + 어드민 등록·수정·삭제)
const QUIET = { skipLoading: true, skipGlobalError: true };

export const getPolicyVersions = async (policyKey) => {
  const response = await axiosInstance.get(`/policies/${policyKey}/versions`, {
    ...QUIET,
    skipAuthRefresh: true,
    timeout: 5000,
  });
  return response.data.data;
};

export const getPolicyVersion = async (policyKey, effectiveDate) => {
  const response = await axiosInstance.get(
    `/policies/${policyKey}/versions/${effectiveDate}`,
    { ...QUIET, skipAuthRefresh: true, timeout: 5000 },
  );
  return response.data.data;
};

export const listAdminPolicyVersions = async (policyKey) => {
  const response = await axiosInstance.get(
    `/admin/policies/${policyKey}/versions`,
    QUIET,
  );
  return response.data.data;
};

export const getAdminPolicyVersion = async (id) => {
  const response = await axiosInstance.get(`/admin/policies/versions/${id}`, QUIET);
  return response.data.data;
};

export const createPolicyVersion = async (policyKey, payload) => {
  const response = await axiosInstance.post(
    `/admin/policies/${policyKey}/versions`,
    payload,
    QUIET,
  );
  return response.data.data;
};

export const updatePolicyVersion = async (id, payload) => {
  const response = await axiosInstance.put(
    `/admin/policies/versions/${id}`,
    payload,
    QUIET,
  );
  return response.data.data;
};

export const deletePolicyVersion = async (id) => {
  await axiosInstance.delete(`/admin/policies/versions/${id}`, QUIET);
};
